import { render, staticRenderFns } from "./myTest.vue?vue&type=template&id=3b310c92&scoped=true"
import script from "./myTest.vue?vue&type=script&lang=js"
export * from "./myTest.vue?vue&type=script&lang=js"
import style0 from "./myTest.vue?vue&type=style&index=0&id=3b310c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b310c92",
  null
  
)

export default component.exports